import { requestAndParse, requestSuccessful } from '../request';

const resetPassword = async (userId: number, password: string) => {
    const route = 'admin/reset-password';
    const payload = {
        userId,
        password,
    };

    const response = await requestAndParse(route, payload);

    const success = requestSuccessful(response);
    const message = response.body?.message as string;

    return { success, message };
};

export default resetPassword;
